export default function MySQL_WEEK() {
  return (
    <div>
      <h2>MySQL_WEEK</h2>    </div>
  );
}